// Game physics constants
export const PHYSICS = {
  // Set ground level to 0.7 to raise characters out of the ground
  GROUND_LEVEL: 0.7,
  GROUND_OFFSET: 0.2, // Character feet offset
  GRAVITY: 9.8, // Gravity force
  JUMP_FORCE: 5, // Jump initial velocity
  MAX_SPEED: 15, // Maximum movement speed
  BROADCAST_INTERVAL: 100, // Server broadcast rate (ms)
};
